import React, {useState} from 'react';
import Input from "../../../../UI/Input";
import Button from "../../../../UI/Button";
import {toast} from "react-toastify";

const ModalBodyAddDetails = (props) => {
    const [value, setValue] = useState("")
    const {id, floatingAccountCode} = props.modalData

    const clickHandler = () => {

        if (value === "") {
            toast.error("عنوان شناوری را وارد کنید")
        } else {
            props.addHandler(value, id, floatingAccountCode)
        }
    }
    return (
        <div className="float-modal-style">
            نام جدید:
            <Input value={value} onChange={(e) => setValue(e.target.value)} type={"text"}/>
            <div className={"text-center mt-4"}>
                <Button color={'pBtn'} onClick={clickHandler}> افزودن شناوری </Button>
                <Button color={'redBtn'} onClick={props.closeModal}> لغو </Button>
            </div>

        </div>
    );
};

export default ModalBodyAddDetails;
